import { ISseOrderEvent, ISseOrderStatusData } from 'orders/types';
import { QuoteStatus } from 'quotes/enums';

const ORDER_STATUSES = new Set(Object.values(QuoteStatus));

const isValidQuoteStatus = (status: string): status is QuoteStatus =>
  ORDER_STATUSES.has(status as QuoteStatus);

export const parseOrderSseEvent = (event: ISseOrderEvent): ISseOrderStatusData | null => {
  const { status } = event.internalOrder;

  if (!isValidQuoteStatus(status)) {
    return null;
  }

  return {
    eventType: event.eventType,
    order: {
      externalOrderErrorMessage: event.internalOrder.externalOrderErrorMessage ?? null,
      externalOrderNumber: event.internalOrder.externalOrderNumber ?? null,
      externalOrderUrl: event.internalOrder.externalOrderUrl ?? null,
      externalStatus: event.internalOrder.externalStatus ?? null,
      id: event.internalOrder.id,
      status,
    },
    timestamp: event.timestamp,
  };
};
